import { render, staticRenderFns } from "./OnHoldReport.vue?vue&type=template&id=ef756aba&"
import script from "./OnHoldReport.vue?vue&type=script&lang=js&"
export * from "./OnHoldReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports